<template>
  <section class="vbox">
    <section class="scrollable padder">
      <section class="row m-b-md brud-theme">
        <div class="col-sm-6 text-black">
          <ol class="breadcrumb text-left">
            <li>
              <a href="#"><i class="fa fa-dashboard"></i> Reports</a>
            </li>
            <li class="active">Purchase Report</li>
          </ol>
        </div>
        <div class="col-sm-6 text-right text-left m-t-sm">
          <small> </small>
        </div>
      </section>

      <section class="panel panel-default">
        <header class="panel-heading">
          <div class="row">
            <div class="col-sm-12">
              <h4>
                <i class="fa fa-list-ul"></i>
                Purchase Report
              </h4> 
            </div>
          </div>
        </header>
        <div class="modal-body">          
          <div class="row">
            <div class="col-md-3">
             <div style="display:flex">
              <label style="line-height: 2.5;">From:</label>
              <input
                type="date"
                class="form-control"
                @change="$refs.table.refresh()"
                id="start-date"
                v-model="startDate"
              />
              </div>
            </div>
            <div class="col-md-3">
             <div style="display:flex">
              <label style="line-height: 2.5;">To:</label>
              <input
                type="date"
                class="form-control"
                id="end-date"
                v-model="endDate"
              />
              </div>
            </div>
            <div class="col-md-6">
             <div style="display:flex">
              <label style="line-height: 2.5;">Supplier:</label>                 
                  <v-select style="width:100%" label="supplier_name" v-model="supplier" :options="supplierList"></v-select>
              </div>
            </div>
            <div class="col-md-6">
             <div style="display:flex">
              <label style="line-height: 2.5;">Project:</label>                 
                  <v-select style="width:100%" label="project_name"  @input="setProject" v-model="project" :options="projectList"></v-select>
              </div>
            </div>
            <div class="col-md-6">
             <div style="display:flex">
              <label style="line-height: 2.5;">Location:</label>                 
                  <v-select style="width:100%;" label="site_name" v-model="location" :options="locationList"></v-select>
              </div>
            </div>
          </div>
          <hr/>
          
          <div class="co-md-12">
            <b-table id="item-table"
              :items="filteredList" 
              ref="table"
              primary-key="purchase_id"
              :fields="fields"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
              :filter="filter"
              hover
              :per-page="perPage"
              :current-page="currentPage">
              <!-- A virtual column -->
              <template #cell(sno)="data">
                {{ (currentPage - 1) * perPage + data.index + 1 }}
              </template>
              <template #cell(order_date)="data">
                {{ dateFormat(data.item.order_date) }}
              </template>
              <template #cell(purchase_id)="data">
                {{ 'LPO-' + data.item.purchase_id }}
              </template>
              <template #cell(action)="data">
                {{ data.item.currency + ' ' + data.item.amount }}
              </template>
            </b-table>
          <!-- Show pagination links -->
          <div>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              aria-controls="item-table"
              hide-ellipsis
              ></b-pagination>
                <json-excel 
                  class="btn btn-success"
                  style="float: right;"
                  :data="filteredList"
                  :fields="exportFields"
                  name="purchase-orders.xls"
                  >
                  Export
                </json-excel>
              
            </div>
            </div>
        </div>
      </section>
    </section>
  </section>
</template>

<script>

import api from "../api";
import { BTable, BPagination} from 'bootstrap-vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import JsonExcel from "vue-json-excel";

export default {
  name: "PurchaseReport",

  components: {
    BPagination,
    BTable,
    vSelect,
    JsonExcel
  },
  data() {
    return {
      startDate: '',
      endDate: '',
      itemList: [],
      supplierList: [],
      projectList: [],
      locationList: [],
      supplier: null,
      project: null,
      location: null,
      perPage: 10,
      currentPage: 1,
     // totalRows: 1,
      filteredCount: 1,
      fields: [
        { key:'sno', label: '#'},
        { key:'order_date', label: 'Order Date'},
        { key:'purchase_id', label: 'LPO #'},
        { key:'supplier_name', label: 'Supplier'},
        { key:'project_name', label: 'Project'},
        { key:'site_name', label: 'Site/Location'},
        { key:'action', label: 'Actions'},
        ],
      exportFields: {
        'LPO Number': {
          field: 'purchase_id',
          callback: (value) => {
            return `LPO - ${value}`;
          },
        },
        'Order Date': 'order_date',
        'Reference #': 'reference_number',
        'Supplier': 'supplier_name',
        'Project': 'project_name',
        'Location': 'site_name',
        'Amount': 'amount',
        'Payment Term': 'payment_term_name',
        'Remarks': 'remarks',
        'Requested By': 'requested_by',
        'Prepared By': 'prepared_by'
      }
    };
  },
  computed: {
    lpoNumber: function () {
      return 'LPO-' + this.itemId;
    },
    filteredList: function () {
       const startDate = this.startDate ? new Date(this.startDate) : null
       const endDate = this.startDate ? new Date(this.endDate) : null
       const supplier = this.supplier
       const project = this.project
       const location = this.location
       const list = this.itemList.filter(function(item) {
        const orderDate = new Date(item.order_date)
        const dateFilter =  (startDate && (orderDate < startDate) ? false : true) && (endDate && (orderDate > endDate) ? false : true)
        const supplierFilter = supplier ? item.supplier_id == supplier.supplier_id : true;
        const projectFilter = project ? item.project_id == project.project_id : true;
        const siteFilter = location ? item.site_id == location.site_id : true;
        return dateFilter && supplierFilter && projectFilter && siteFilter 
      });
      return list
    },
    totalRows: function () {
      return this.filter && this.filter.length ? this.filteredCount : this.filteredList.length
    }
  },
  methods: {
    setProject: function (value) {
      this.getLocations(value.project_id);
    },
    dateFormat: function(date) {
      /* var options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      }; */
      var formatdate = new Date(date);
      var dateformat = formatdate.toLocaleDateString("en-GB");
      return dateformat;
    },
    getList: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_purchases", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            if (data.errorcode === 25000) {
              this.$router.push('/login')
            }
            this.itemList = response.data.values;
          } else {
            this.itemList = data.purchaseList;
          }
        });
    },
    getCartList: function(id) {
      const list = {
        filter: {
          purchase_id: id
        },
      };
      api
        .request("post", "GeneralApis/get_purchase_items", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            this.productList = response.data.values;
          } else {
            this.productList = data.cartList;
          }
        });
    },
    showForm: function(purchaseid, show=false, copy=false) {
      this.copyLPO = copy;
      this.showLPO = show;
      this.itemId = purchaseid;
      this.showFormModal = true;
    },
    viewLPO: function(item) {
      this.selectedItem = item;
      this.showLPO = true;
      this.itemId = item.purchase_id;
      this.showFormModal = true;
    },
    showCart: function(purchaseid) {
      this.getCartList(purchaseid)
      this.showCartModal = true;
    },
    onFiltered(filteredItems) {
      this.filteredCount = filteredItems.length
      this.currentPage = 1
    },
    getSuppliers: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_suppliers", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            this.supplierList = [];
          } else {
            this.supplierList = data.supplierList;
          }
        });
    },
    getProjects: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_projects", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            this.projectList = [];
          } else {
            this.projectList = data.projectList;
          }
        });
    },
    getLocations: function(id = null) {
      const list = { filter: {project_id: id} };
      api
        .request("post", "GeneralApis/get_sites", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            this.locationList = [];
          } else {
            this.locationList = data.siteList;
          }
        });
    }
  },
  mounted(){
    this.getList()
    this.getSuppliers()
    this.getProjects()
    this.getLocations()
  }
};
</script>
